import React, { useState } from 'react'
import { Form, Button, Col, Row } from 'react-bootstrap';

import './styles.css'
import 'bootstrap/dist/css/bootstrap.min.css';


const RegisterTable = (props) => {

    // DAG information
    const [submitter, setSubmitter]             = useState('')
    const [runSchedule, setRunSchedule]         = useState('')
    const [emailOnFailure, setEmailOnFailure]   = useState('')

    // Source: ingestion information
    const [sourceDatabase, setSourceDatabase]   = useState('')
    const [systemDatabase, setSystemDatabase]   = useState('')
    const [schemaName, setSchemaName]           = useState('')
    const [table, setTable]                     = useState('')
    const [volumetry, setVolumetry]             = useState('')
    const [typeLoad, setTypeLoad]               = useState('')
    const [deltaColumn1, setDeltaColumn1]       = useState('')
    const [deltaColumn2, setDeltaColumn2]       = useState('')
    const [deltaOperation, setDeltaOperation]   = useState('')

    // Datalake: ingestion information
    const [partitioned, setPartitioned]         = useState('')

    const fields = {
        'source_database': ['Oracle', 'Postgresql', 'SQLserver', 'Mysql', 'SAPHana'],
        'system_database': {
            'Oracle': ['O01DW', 'O02DW', 'O02PR', 'O05PR', 'O44PRDG', 'O74PR', 'O76PR', 'O80PRDG', 'O54PR', 'O01DWH', 'O02DWH'],
            'Postgresql': ['CADWF', 'CMM', 'BRM', 'TABLEAU'],
            'SQLserver': ['crmbi-prd'],
            'Mysql': ['INTENCAO'],
            'SAPHana': ['JH5', 'FYW'],
            '': []
        },
        'volumetry': ['1-1000000', '1000001 - 10000000', '> 10000000'],
        'tipo_carga': ['Delta', 'Full']
    }

    // **** TAREFAS PENDENTES **** 
    // traduzir as string volumetry p/ inteiro mappers, conforme abaixo: 
    // '1-1000000': 1,
    // '1000001 - 10000000': 5,
    // '> 10000000': 15

    // traduzir as string volumetry p/ inteiro fetch_size, conforme abaixo: 
    // '1-1000000': "",
    // '1000001 - 10000000': "10000",
    // '> 10000000': "15000"

    const handleSubmit = (Event) => {
        Event.preventDefault();

        const data = {
            "submitter": submitter,
            "run_schedule": runSchedule,
            "email_on_failure": emailOnFailure,
            "source_database": sourceDatabase,
            "system_database": systemDatabase,
            "schema_name": schemaName,
            "table_name": table,
            "volumetry": volumetry,
            "type_load": typeLoad,
            "delta_column1": deltaColumn1,
            "delta_column2": deltaColumn2,
            "delta_operation": deltaOperation,
            "partitioned": partitioned,
            "incremental_overwrite": "O",
            "file_name": schemaName + "." + table,
            "frequency": "d",
            "destination": "s3://natura-datalake-dev/raw/" + schemaName + "/",
            "file_path": "s3://natura-datalake-dev/raw/" + table + "/",
            "database_name": "raw",
            "delimiter": "|",
            "driver": "",
            "split_by": "",
            "db_id": "",
            "condition_where": "",
            "mappers": "",
            "fetch_size": "",
            "cast_name": "",
            "ignore_name": "",
            "user_id": "",
            // variáveis do ambiente
            "env": "dev",
            "source_type": "jdbc",
            "layer": "all"
        }

        if (!submitter.length | !runSchedule.length | !emailOnFailure.length | !sourceDatabase.length | !systemDatabase.length | !schemaName.length | !table.length | !volumetry.length | !typeLoad.length | !partitioned.length) {
            alert('Campos obrigatórios devem ser preenchidos')
        } else if (typeLoad === 'Delta' && !deltaColumn1.length ) {
            alert("Campo obrigatório 'delta column 1' deve ser preenchido")
        } else if (typeLoad === 'Delta' && deltaColumn1.length > 0 && deltaColumn2.length > 0 && !deltaOperation.length) {
            alert("Campo obrigatório 'Delta Column Operation' deve ser preenchido")
        } else {
            console.log('*** ENVIAR DADOS PARA API ***', data)
        }
    }

    return (
        <div>

            <div className="regTable-btn-back">
                <Button variant="light" onClick={props.handleBack} >Back</Button>
            </div>

            <div className="regTable-container">

                <Form className="regTable-form" onSubmit={handleSubmit}>
                    <h1 className="regTable-title">Dag Information</h1>
                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Submitter *</Form.Label>
                                <Form.Control type="text" placeholder="Enter submitter" onChange={(e) => setSubmitter(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col xs={5}>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Run Schedule * (Crontab Format) </Form.Label>
                            <Form.Control type="text" placeholder="Enter Run Schedule" onChange={(e) => setRunSchedule(e.target.value)} />
                        </Form.Group>
                        </Col>

                        <Col xs={5}>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>E-mail on failure * </Form.Label>
                            <Form.Control type="email" placeholder="Enter e-mail on failure" onChange={(e) => setEmailOnFailure(e.target.value)} />
                        </Form.Group>
                        </Col>
                    </Row>

                    <hr />

                    <h1 className="regTable-title">Source: Ingestion Information</h1>
                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Source Database *</Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => setSourceDatabase(e.target.value)} >
                                    <option></option>
                                    {fields.source_database.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Database System * (Crontab Format) </Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => setSystemDatabase(e.target.value)} >
                                    <option></option>
                                    {fields.system_database[sourceDatabase].map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                        </Form.Group>
                        </Col>
                    </Row>

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>SchemaName *</Form.Label>
                                <Form.Control type="text" placeholder="Enter SchemaName"  onChange={(e) => setSchemaName(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Table *</Form.Label>
                                <Form.Control type="text" placeholder="Enter Table" onChange={(e) => setTable(e.target.value)} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Volumetry *</Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => setVolumetry(e.target.value)} >
                                    <option></option>
                                    {fields.volumetry.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Delta/Full *</Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => setTypeLoad(e.target.value)} >
                                    <option></option>
                                    {fields.tipo_carga.map((item, index) => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                        </Form.Group>
                        </Col>
                    </Row>
                    
                    {/* exibi essa linha apenas quando tipo da carga for Delta */}
                    {typeLoad === 'Delta' ?
                        <Row className="g-3">
                            <Col md>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Delta Column 1</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Delta Column 1" onChange={(e) => setDeltaColumn1(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md>
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Delta Column 2</Form.Label>
                                    <Form.Control type="text" placeholder="Enter Delta Column 2" onChange={(e) => setDeltaColumn2(e.target.value)} />
                                </Form.Group>
                            </Col>

                            <Col md>
                                {deltaColumn1.length > 0 && deltaColumn2.length > 0 ? 
                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Delta Column Operation</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={(e) => setDeltaOperation(e.target.value)} >
                                        <option></option>
                                        <option value="and">and</option>
                                        <option value="or">or</option>
                                    </Form.Select>
                                </Form.Group>
                                : null}
                            </Col>
                        </Row>
                    : null }
                    

                    <hr />

                    <h1 className="regTable-title">Datalake: Ingestion Information</h1>
                    <Row className="g-3">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Partitioned *</Form.Label>
                                <Form.Select aria-label="Default select example" onChange={(e) => setPartitioned(e.target.value)} >
                                    <option></option>
                                    <option value="yes">yes</option>
                                    <option value="no">no</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={10} />
                    </Row>

                    <div className="regTable-button">
                        <Button variant="primary" type="submit">
                            Register Table
                        </Button>
                    </div>

                    <p className="regTable-mandatory">* Mandatory fields</p>
                </Form>
            </div>
        </div>
    );
}

export default RegisterTable;